import { createSlice } from '@reduxjs/toolkit'
import { getSession, setSession, clearSession } from '../../utils/session'

const initial = getSession()

// Auth state mirrors the persisted session (token + user). Components can read
// from redux for reactivity; the session util remains the storage source of truth.
export const authslice = createSlice({
  name: 'auth',
  initialState: {
    token: initial?.token || null,
    user: initial?.user || null,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload.user
      state.token = action.payload.token
      setSession({ token: action.payload.token, user: action.payload.user })
    },
    logout: (state) => {
      state.user = null
      state.token = null
      clearSession()
    },
  },
})
